import { hasRecommendationsEntitlement } from '../../../../utils/recommendationsEntitlement';
import { isCapabilityVisible, hasLoadedCapabilities } from '../../../../utils/capabilityUtils';

const hasSubmodulePermission = (permissions, keyPermission) =>
  permissions?.some((module) => module.submodules?.includes(keyPermission));

const isMenuItemVisible = (item, settings) => {
  if (!item.showMenu) return false;

  if (
    item.capabilityKey &&
    hasLoadedCapabilities(settings.capabilities) &&
    !isCapabilityVisible(settings.capabilities, item.capabilityKey)
  ) {
    return false;
  }

  if (item.key === 'recommendations') {
    return hasRecommendationsEntitlement(settings?.permissions);
  }

  if (!item.keyPermission) return true;
  return hasSubmodulePermission(settings.permissions, item.keyPermission);
};

/**
 * Returns visible submenu items for a nav group, or null when the group should be hidden.
 */
export const getVisibleSubmenuItems = (group, settings) => {
  if (!group?.items?.length) return null;

  if (group.crmAccessGated) {
    if (!settings?.crmAccessEnabled) return null;
    const items = group.items.filter((item) => isMenuItemVisible(item, settings));
    return items.length === 0 ? null : items;
  }

  if (!group.keyPermission) {
    return group.items;
  }

  const moduleExists = settings?.permissions?.find((module) => module.key === group.keyPermission);
  if (!moduleExists) return null;

  const submenuItems = group.items.filter((item) => isMenuItemVisible(item, settings));
  return submenuItems.length === 0 ? null : submenuItems;
};
